import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ContentLayoutComponent } from '@app/core/layout/logged-in-layout/content-layout.component';
import { AdminGuard } from '@app/core/guards/admin/admin.guard';
import { BillingGuard } from '@app/core/guards/billing/billing.guard';
import { NotLoggedInLayoutComponent } from '@app/core/layout/not-logged-in-layout/not-logged-in-layout.component';
import { ChangePasswordRequestComponent } from '@app/shared/components/change-password-request/change-password-request.component';
import { ChangePasswordComponent } from '@app/shared/components/change-password/change-password.component';
import { ForgotLoginComponent } from '@app/modules/login/forgot-login/forgot-login.component';
import { SupportComponent } from './modules/settings/support/support.component';
import { ProfileComponent } from './modules/organization/profile/profile.component';
import { CallbackComponent } from './modules/quick-books/pages/callback/callback.component';
import { SocialPopupComponent } from './modules/login/social-popup/social-popup.component';

const routes: Routes = [
  {
    // Public, unauthenticated, embeddable (iframe) barcode lookup page.
    // No guard and no app chrome (standalone module).
    path: 'lookup',
    loadChildren: () => import('./modules/public-lookup/public-lookup.module').then(m => m.PublicLookupModule),
  },
  {
    // Reachable while signed in but locked out for non payment, so it sits
    // outside the guarded layout
    path: 'payment-required',
    loadChildren: () => import('./modules/billing/billing.module').then(m => m.BillingModule),
  },
  {
    path: 'super-admin',
    loadChildren: () => import('./modules/super-admin/super-admin.module').then(m => m.SuperAdminModule),
  },
  {
    path: '',
    component: ContentLayoutComponent,
    canActivate: [AdminGuard, BillingGuard],
    children: [
      {
        path: '',
        loadChildren: () => import('./modules/home/home.module').then(m => m.HomeModule),
        data: {
          title: "home"
        }
      },
      {
        path: 'products',
        loadChildren: () => import('./modules/products/products.module').then(m => m.ProductsModule),
      },
      {
        path: 'reports',
        loadChildren: () => import('./modules/reports/reports.module').then(m => m.ReportsModule),
      },
      {
        path: 'storages',
        loadChildren: () => import('./modules/storages/storages.module').then(m => m.StoragesModule),
      },
      {
        path: 'label-designer',
        loadChildren: () => import('./modules/label-designer/label-designer.module').then(m => m.LabelDesignerModule),
      },
      {
        path: 'counts',
        loadChildren: () => import('./modules/counts/counts.module').then(m => m.CountsModule),
      },
      {
        path: 'administration',
        loadChildren: () => import('./modules/organization/organization.module').then(m => m.OrganizationModule),
      },
      {
        path: 'pickings',
        loadChildren: () => import('./modules/pickings/pickings.module').then(m => m.PickingsModule),
      },
      {
        path: 'receivings',
        loadChildren: () => import('./modules/receivings/receivings.module').then(m => m.ReceivingsModule),
      }, 
      {
        path: 'picklists',
        loadChildren: () => import('./modules/picklists/picklists.module').then(m => m.PicklistsModule),
      },
      {
        path: 'tasks',
        loadChildren: () => import('./modules/tasks/tasks.module').then(m => m.TasksModule),
      },
      {
        path: 'asset', loadChildren: () => import('./modules/asset/asset.module').then(m => m.AssetModule),
      },
      {
        path: 'asset-borrows', loadChildren: () => import('./modules/asset-borrows/asset-borrows.module').then(m => m.AssetBorrowsModule),
      },
      {
        path: 'settings', loadChildren: () => import('./modules/settings/settings.module').then(m => m.SettingsModule),
      },
      {
        path: 'users', loadChildren: () => import('./modules/users/users.module').then(m => m.UsersModule),
      },
      {
        path: 'integrations', loadChildren: () => import('./modules/integrations/integrations.module').then(m => m.IntegrationsModule),
      },
      {
        path: 'health-check', loadChildren: () => import('./modules/health-check/health-check.module').then(m => m.HealthCheckModule),
      },
      {
        path:'profile',
        component: ProfileComponent,
        data: {
          title: "profile"
        } 
      },
      {
        path: 'support', component: SupportComponent,
        data: {
          title: "support"
        }
      },
    ]
  },
  {
    path: 'quick-books/callback',
    component: CallbackComponent,
    pathMatch: 'full',
    canActivate: [AdminGuard],
  },
  {
    path: '',
    component: NotLoggedInLayoutComponent,
    children: [
      {
        path: 'login', loadChildren: () => import('./modules/login/login.module').then(m => m.LoginModule),
      },
      { 
        path: 'reset-password', component: ChangePasswordRequestComponent 
      },
      { 
        path: 'update-password', component: ChangePasswordComponent 
      },
      { 
        path: 'authorized/google/callback', component: SocialPopupComponent 
      },
      { 
        path: 'authorized/facebook/callback', component: SocialPopupComponent 
      },
      { 
        path: 'authorized/apple/callback', component: SocialPopupComponent 
      },
      { 
        path: 'forgot-login', 
        component: ForgotLoginComponent
      }
    ]
  },
  {
    // Any other address used to render a blank page (NG04002); send it home,
    // where the guards take over.
    path: '**',
    redirectTo: ''
  },

];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})

export class AppRoutingModule { }